export const employeesColumns = [
  {
    id: 'estado', label: 'Estado', type: 'select', sortable: true, required: false, options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ]
  },
  { id: 'cedula', label: 'Número de identificación', type: 'text', sortable: true, required: true },
  { id: 'nombre', label: 'Nombre', type: 'text', sortable: true, required: true },
  { id: 'apellido', label: 'Apellido', type: 'text', sortable: true, required: true },
  { id: 'correo', label: 'Correo', type: 'text', sortable: true, required: false },
  { id: 'celular', label: 'Celular', type: 'text', sortable: true, required: false },
  { id: 'direccion', label: 'Direccion', type: 'text', sortable: true, required: false },
  {
    id: 'rol', label: 'Rol', type: 'select', sortable: true, required: false, options: [
      { value: 'Administrador', label: 'Administrador' },
      { value: 'Asesor Comercial', label: 'Asesor Comercial' },
      { value: 'Coordinador de propiedad', label: 'Coordinador de propiedad' },
      { value: 'Camarera', label: 'Camarera' },
      { value: 'Conductor', label: 'Conductor' },
    ]
  },
  { id: 'salario', label: 'Salario', type: 'number', sortable: true, required: false },
  { id: "EPS", label: "EPS", type: "text", sortable: true, required: false },
  { id: "nombre_contacto_emergencia", label: "Nombre Contacto Emergencia", type: "text", sortable: true, required: false },
  { id: "telefono_contacto_emergencia", label: "Telefono Contacto Emergencia", type: "text", sortable: true, required: false },
  { id: "parentesco_contacto_emergencia", label: "Parentesco Contacto Emergencia", type: "select", sortable: true, required: false, options: [
    { value: 'Hijo', label: 'Hijo' },
    { value: 'Hermano', label: 'Hermano' },
    { value: 'Padre', label: 'Padre' },
    { value: 'Madre', label: 'Madre' },
    { value: 'Conyuge', label: 'Conyuge' },
    { value: 'Otros', label: 'Otros' },
  ] },
  { id: "diaDescanso", label: "Dia Descanso", type: "select", sortable: true, required: false, options: [
    { value: 'Lunes', label: 'Lunes' },
    { value: 'Martes', label: 'Martes' },
    { value: 'Miercoles', label: 'Miercoles' },
    { value: 'Jueves', label: 'Jueves' },
    { value: 'Viernes', label: 'Viernes' },
    { value: 'Sabado', label: 'Sabado' },
    { value: 'Domingo', label: 'Domingo' },
  ] },
];


export const columnsExcel = [
  { key: 'estado', header: 'Estado' },
  { key: 'cedula', header: 'Número de identificación' },
  { key: 'nombre', header: 'Nombre' },
  { key: 'apellido', header: 'Apellido' },
  { key: 'correo', header: 'Correo' },
  { key: 'celular', header: 'Celular' },
  { key: 'direccion', header: 'Direccion' },
  { key: 'rol', header: 'Rol' },
  { key: 'salario', header: 'Salario' },
  { key: 'EPS', header: 'EPS' },
  { key: 'arl', header: 'ARL' },
]
